var _dec, _dec2, _dec3, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { CustomerService } from '@square/dashboard-protos/models/squareup/sfs/external/services/customer/customer_service';
import Service, { inject as service } from '@ember/service';
import { computed, set } from '@ember/object';
import rpc, { apiHostUrl } from '@banking/api/utils/rpc';
import { Money, Currency } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
let SfsCustomerApi = (_dec = computed('capitalEngineContext.headers'), _dec2 = computed('customerLimits.{odfiDepositAmountLimit,odfiDepositAmountSum}'), _dec3 = computed('customerLimits.{odfiWithdrawalAmountLimit,odfiWithdrawalAmountSum}'), _class = class SfsCustomerApi extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _defineProperty(this, "features", []);
    _defineProperty(this, "currentCustomer", void 0);
    _defineProperty(this, "customerLimits", void 0);
  }
  get client() {
    return CustomerService.create(rpc(apiHostUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  get remainingWeeklyDeposits() {
    if (this.customerLimits?.odfiDepositAmountLimit && this.customerLimits?.odfiDepositAmountSum) {
      const {
        odfiDepositAmountLimit,
        odfiDepositAmountSum
      } = this.customerLimits;
      if (odfiDepositAmountLimit.currency !== odfiDepositAmountSum.currency) {
        throw new Error(`Can not subtract Money objects with different currency codes:
            ${odfiDepositAmountLimit.currency} vs. ${odfiDepositAmountSum.currency}`);
      }
      const amount = odfiDepositAmountLimit.amount - odfiDepositAmountSum.amount;
      return Money.create({
        amount,
        currency: Currency.USD
      });
    } else {
      return null;
    }
  }
  get remainingWeeklyWithdrawals() {
    if (this.customerLimits?.odfiWithdrawalAmountLimit && this.customerLimits?.odfiWithdrawalAmountSum) {
      const {
        odfiWithdrawalAmountLimit,
        odfiWithdrawalAmountSum
      } = this.customerLimits;
      if (odfiWithdrawalAmountLimit.currency !== odfiWithdrawalAmountSum.currency) {
        throw new Error(`Can not subtract Money objects with different currency codes:
            ${odfiWithdrawalAmountLimit.currency} vs. ${odfiWithdrawalAmountSum.currency}`);
      }
      const amount = odfiWithdrawalAmountLimit.amount - odfiWithdrawalAmountSum.amount;
      return Money.create({
        amount,
        currency: Currency.USD
      });
    } else {
      return null;
    }
  }

  // eslint-disable-next-line unicorn/no-object-as-default-parameter
  async retrieveCustomer({
    refresh
  } = {
    refresh: false
  }) {
    if (!this.currentCustomer || refresh) {
      const {
        customer,
        featureFlags
      } = await this.client.retrieveCustomer({});
      set(this, 'currentCustomer', customer);
      this.features = [];
      for (const feature of featureFlags?.flags ?? []) {
        this.features.push(feature);
      }
    }

    // Make sure we don't return a nullable customer. This should never happen
    // but technically the field on the proto is nullable.
    if (!this.currentCustomer) {
      throw new Error('failed to retrieve customer');
    }
    return {
      customer: this.currentCustomer,
      features: this.features
    };
  }

  /**
   * Retrieves specific customer fields without caching.
   * Use this when you only need specific fields to avoid triggering expensive
   * external dependency calls for fields you don't need.
   *
   * NOTE: This method never uses or updates the cache, so it always makes a
   * fresh API call. Only request fields that are cheap to fetch (e.g.,
   * 'customer.application_flows' is stored in DB, but 'is_locked' may trigger
   * expensive downstream calls).
   *
   * @param fieldsToInclude - Array of field paths to retrieve (e.g., ['customer.application_flows'])
   * @returns Promise with customer data containing only the requested fields
   */
  async retrieveCustomerFields({
    fieldsToInclude
  }) {
    const {
      customer,
      featureFlags
    } = await this.client.retrieveCustomer({
      fieldsToInclude
    });

    // Make sure we don't return a nullable customer
    if (!customer) {
      throw new Error('failed to retrieve customer');
    }
    return {
      customer,
      features: featureFlags?.flags ?? []
    };
  }

  // eslint-disable-next-line unicorn/no-object-as-default-parameter
  async retrieveCustomerLimits({
    refresh
  } = {
    refresh: false
  }) {
    if (!this.customerLimits || refresh) {
      const {
        customerLimits
      } = await this.client.retrieveCustomerLimits({});
      set(this, 'customerLimits', customerLimits);
    }

    // Make sure we don't return a nullable customer limits. This should never happen
    // but technically the field on the proto is nullable.
    if (!this.customerLimits) {
      throw new Error('failed to retrieve customer limits');
    }
    return {
      customerLimits: this.customerLimits
    };
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remainingWeeklyDeposits", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "remainingWeeklyDeposits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remainingWeeklyWithdrawals", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "remainingWeeklyWithdrawals"), _class.prototype), _class);
export { SfsCustomerApi as default };